import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, onMounted, onUnmounted, ref, useSlots } from 'vue';
import CButton from '@/components/shared/CButton';
import CError from '@/components/shared/CError.vue';
import CPreview from '@/components/shared/CPreview.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CFileInput',
  props: {
    value: null,
    initialFilesSrc: { default: () => [] },
    allowSrcRemove: { type: Boolean },
    dragAndDrop: { type: Boolean },
    multiple: { type: Boolean },
    accept: { default: '*' },
    maxMbSize: { default: 10 },
    buttonText: null,
    previewButtonText: null,
    displayPreview: { type: Boolean, default: true },
    previewLabel: null,
    disabled: { type: Boolean },
    error: { type: Boolean },
    errorMsg: null
  },
  emits: ["input", "cancel", "src-preview-removed"],
  setup(__props: any, { expose, emit }: { emit: ({
    (event: 'input', value: File[]): void;
    (event: 'cancel'): void;
    (event: 'src-preview-removed', value: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: File[], initialFilesSrc: string[], allowSrcRemove?: boolean, dragAndDrop?: boolean, multiple?: boolean, accept: string, maxMbSize: number, buttonText?: string, previewButtonText?: string, displayPreview: boolean, previewLabel?: string, disabled?: boolean, error?: boolean, errorMsg?: string };





const slots = useSlots();

const fileInputRef: Ref<HTMLInputElement | null> = ref(null);

const _initialSrcs = ref<string[]>(props.initialFilesSrc);

const files = computed({
    get: () => (props.value.length ? props.value : [..._initialSrcs.value]),
    set: (files: string[] | File[]): void => emit('input', files as File[])
});

const previewMode = computed(() => files.value.length);

const allowPreviewRemove = computed(
    () => !props.disabled && ((files.value.length !== 1 && !props.dragAndDrop) || props.allowSrcRemove)
);

const btnText = computed(() => (previewMode.value ? props.previewButtonText : props.buttonText));

const openFileUploader = () => fileInputRef.value?.click();

const handleFileChange = (event: Event) => {
    const element = event.target as HTMLInputElement;
    updateModel(element.files);
};

const handleDragOver = (event: DragEvent) => {
    event.preventDefault();
    if (!event.dataTransfer || props.disabled) return;
    event.dataTransfer.dropEffect = 'copy';
};

const handleDrop = (event: DragEvent) => {
    event.preventDefault();
    if (!event.dataTransfer || props.disabled) return;

    updateModel(event.dataTransfer.files, props.multiple);
};

const removeFile = (index?: number) => {
    clearInput();

    if (index == undefined) {
        files.value = [];
        return;
    }

    if (typeof files.value[index] == 'string') {
        _initialSrcs.value.splice(index, 1);
        emit('src-preview-removed', _initialSrcs.value);
        return;
    }

    files.value.splice(index, 1);
};

const clearInput = () => {
    if (!fileInputRef.value) return;
    fileInputRef.value.value = '';
};

const updateModel = (list: FileList | null, concat?: boolean) => {
    const newFiles: File[] = [];

    /**
     * Use a forof to manually push each file to model array,
     * since Array.from and spread operator dont work properly
     * clonning a FileList
     */
    for (const file of list || []) {
        if (!isValidFileFormat(file)) continue;
        if (!props.multiple && newFiles.length) break;
        newFiles.push(file);
    }

    files.value = concat ? [...(files.value as File[]), ...newFiles] : newFiles;
};

const isValidFileFormat = (file: File): boolean => {
    if (!props.accept.length || props.accept == '*') return true;

    const allowedTypes = props.accept.split(',');
    const fileExtension = file.name.split('.').at(-1)?.toLowerCase();

    return allowedTypes.some((type) => [`.${fileExtension}`, file.type].includes(type));
};

const selectionCanceled = () => {
    clearInput();
    emit('cancel');
};

onMounted(() => {
    fileInputRef.value?.addEventListener('cancel', selectionCanceled);
});

onUnmounted(() => {
    fileInputRef.value?.removeEventListener('cancel', selectionCanceled);
});

expose({ openFileUploader });

return { __sfc: true,props, emit, slots, fileInputRef, _initialSrcs, files, previewMode, allowPreviewRemove, btnText, openFileUploader, handleFileChange, handleDragOver, handleDrop, removeFile, clearInput, updateModel, isValidFileFormat, selectionCanceled, CButton, CError, CPreview }
}

})